import { Product } from '../../product/state/product.model';

export interface CartItem {
    productId: Product['id'];
    title: string;
    description: string;
    unitPrice: number,
    quantity: number;
    total: number;    
}

/**
 * Factory function that creates cart items
 * @param {Partial<CartItem>} params
 * @returns {CartItem}
 */
export function createCartItem(params: Partial<CartItem>) {
    return {
        total: 0,
        ...params,
    } as CartItem;
}
